export default __webpack_public_path__ + "static/media/par5.67b65670.jpg";